import { Component, effect, ElementRef, inject, InjectionToken } from '@angular/core';
import { SidebarService } from './sidebar.service';
import { Observable, of, take } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { AppConfigService, Log } from '@core/services/config/app-config.service';
import { RouterModule,RouterLink } from '@angular/router';
import { TranslatePipe } from "../../core/pipe/translate.pipe";
import { UpperCasePipe } from '@angular/common';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faGear, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { BackdropService } from '@components/shared/backdrop/backdrop.service';
    

@Component({
    selector: 'app-sidebar',
    imports: [
        AsyncPipe,
        RouterModule,
        RouterLink,
        TranslatePipe,
        UpperCasePipe,
        FontAwesomeModule
    ],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

    backdropService = inject(BackdropService)
    
    indice_marche$: Observable<any> | undefined;
    indice_ricambi$: Observable<any> | undefined;
    menu_indice$: Observable<any> | undefined;
    exists_ricambi:boolean = false;
    show_blog_item: boolean = false;

    faRicambi = faGear;
    faNostriStore = faLocationDot;


    constructor(
        private elementRef: ElementRef,
        private sidebarService: SidebarService,
        private appConfig: AppConfigService
    ) {
        effect(() => {
            if(!this.appConfig.ssr()) {
                if (!this.backdropService.isActive()) {
                    // Rimuovo la classe 'active' dal emp-nav quando la sidebar non è attiva
                    const nav = document.querySelector('.emp-nav');
                    nav?.classList.remove('active');
                }
            }
        });
    }

    ngOnInit() {
        // attivo menu item blog per domini abilitati
        this.show_blog_item = this.appConfig.hasBlog();

        this.sidebarService.getIndex().pipe(take(1)).subscribe({
            next: (menu_indice) => {
                // separo l'indice delle marche da quello dei ricambi

                var indice_marche:any[] = [];
                var indice_ricambi:any[] = [];

                for(var i=0; i<menu_indice.length; i++) {
                    if(menu_indice[i].ricambi) {
                        indice_ricambi.push(menu_indice[i]);
                        this.exists_ricambi = true;
                    } else {
                        indice_marche.push(menu_indice[i]);
                    }
                }

                this.indice_marche$ = of(indice_marche)
                this.indice_ricambi$ = of(indice_ricambi)

            }
        });

        if(this.appConfig.browser()) {
            this.ngOnInitBrowser();
        }
    }

    ngOnInitBrowser() {
        const menuToggle = document.querySelector('.menu-toggle');

        const nav = document.querySelector('nav');

        const overlay = document.querySelector('.overlay');

        overlay?.addEventListener('click', () => {

            const nav = document.querySelector('.emp-nav');
    
            const overlay = document.querySelector('.overlay');

            nav?.classList.remove('active');
            overlay?.classList.remove('active');
        });

        // Applica il click handler a tutti i livelli
        // document.querySelectorAll('.nav-item, .submenu-item').forEach(this.handleSubmenuClick);
    }
    
    handleSubmenuClick(event: MouseEvent) {
        event.stopPropagation();
        event.preventDefault();

        const target = event.currentTarget as HTMLButtonElement;

        const hasSubmenu = target.querySelector('.submenu, .sub-submenu, .sub-sub-submenu');

        if (hasSubmenu) {
            target.classList.toggle('active');
        } else {
            const nav = document.querySelector('.emp-nav');
            nav?.classList.remove('active');
            // nascondo il backdrop
            this.backdropService.hide();

            /* const overlay = document.querySelector('.overlay');


            if(overlay?.classList.contains('active')) {
                overlay?.classList.remove('active');
            } */
        }
    };


    voidClick(event: MouseEvent) {
        event.stopPropagation();
        event.preventDefault();

        const nav = document.querySelector('.emp-nav');
        nav?.classList.remove('active');
            // nascondo il backdrop
            this.backdropService.hide();

        /* const overlay = document.querySelector('.overlay');
        if(overlay?.classList.contains('active')) {
            overlay?.classList.remove('active');
        } */

    }

}
